import { useStores } from '../../../app/root/domain/stores/useStores';

export function useAuthStore() {
	const { authStore } = useStores();

	return authStore;
}
